/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Store</h2>
    <p className={styles.description}>
      <b>Хранилище</b> (<code className={styles.code}>store</code>) - js-объект, который содержит состояние приложения и
      методы доступа к нему, отправки действий и регистрации слушателей.{' '}
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Хранит состояние (<code className={styles.code}>state</code>) приложения как один объект
      </li>
      <li className={styles.list__item}>
        Позволяет получить доступ к состоянию через метод <code className={styles.code}>getState()</code>
      </li>
      <li className={styles.list__item}>Напрямую состояние доступно только для чтения</li>
      <li className={styles.list__item}>
        Единственный способ изменить состояние - отправить действие (<code className={styles.code}>action</code>),
        объект, описывающий, что произошло
      </li>
      <li className={styles.list__item}>
        Для отправки дейсвтий есть метод <code className={styles.code}>dispatch(action)</code>
      </li>
      <li className={styles.list__item}>
        Изменения производятся с использованием чистых функций - редюсеров (
        <code className={styles.code}>reducers</code>), которые реагируют на действия
      </li>
      <li className={styles.list__item}>
        Регистрирация слушателей делается методом <code className={styles.code}>subscribe(listener)</code>
      </li>
    </ul>
    <p className={styles.description}>
      Так как все состояние приложения хранится как один объект, стоит подумать о форме состояния прежде чем писать
      какой-либо код. Продумайте минимальное представление состояния приложения в виде объекта.
    </p>
    <CopyBlock
      text={`const state = {
  notes: [],
  filter: '',
  session: {
    user: {
      name: null,
      avatar: null,
    },
    token: null,
  },
};`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.1 - Функция createStore</h3>
      <p className={styles.description}>
        Для того чтобы создать хранилище, используется функция <code className={styles.code}>createStore</code>, которая
        принимает набор параметров и возвращает созданное хранилище.{' '}
      </p>
      <CopyBlock
        text={`createStore(reducer, [preloadedState], [enhancer])`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <code className={styles.code}>reducer</code> - функция, которая возвращает следующее дерево состояния,
          учитывая текущее дерево состояния и действие для обработки.
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>preloadedState</code> - начальное состояние, к примеру сериализаванное состояние
          последнего пользовательского сеанса. Это должен быть объект той же формы, что и, как минимум, часть состояния.
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>enhancer</code> - расширяет возможности хранилища при помощи прослоек
          (middleware).
        </li>
      </ul>
      <CopyBlock
        text={`import { createStore } from 'redux';

// Используем редюсер-болванку
const reducer = (state = {}, action) => state;

const store = createStore(reducer);
`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>
  </section>
))
